import Vue from 'vue'
import {ACCESS_TOKEN, NAME, SEEKER_INFO} from '@/store/mutation-types'
import {postAction} from '@/api/manage'

const seeker = {
    state: {
        token: '',
        info: '',
        name: ''
    },
    mutations: {
        SET_TOKEN: (state, token) => {
            state.token = token
        },
        SET_INFO: (state, info) => {
            state.info = info
        },
        SET_NAME: (state, name) => {
            state.name = name
        }
    },
    actions: {
        // 登录
        Login({commit}, seeker) {
            return new Promise((resolve, reject) => {
                postAction('/login', seeker).then(response => {
                    if (response.code == '200') {
                        const result = response.result
                        const record = result.record
                        Vue.ls.set(ACCESS_TOKEN, result.token, 24 * 60 * 60 * 1000)
                        Vue.ls.set(SEEKER_INFO, record, 24 * 60 * 60 * 1000)
                        Vue.ls.set(NAME, record.name, 24 * 60 * 60 * 1000)
                        commit('SET_TOKEN', result.token)
                        commit('SET_INFO', record)
                        commit('SET_NAME', record.name)
                        resolve(response)
                    } else {
                        reject(response)
                    }
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 注册
        Register({commit}, seeker) {
            return new Promise((resolve, reject) => {
                postAction('/register', seeker).then(response => {
                    if (response.code == '200') {
                        const result = response.result
                        const record = result.record
                        Vue.ls.set(ACCESS_TOKEN, result.token, 24 * 60 * 60 * 1000)
                        Vue.ls.set(SEEKER_INFO, record, 24 * 60 * 60 * 1000)
                        Vue.ls.set(NAME, record.name, 24 * 60 * 60 * 1000)
                        commit('SET_TOKEN', result.token)
                        commit('SET_INFO', record)
                        commit('SET_NAME', record.name)
                        resolve(response)
                    } else {
                        reject(response)
                    }
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 登出
        Logout({commit}) {
            return new Promise((resolve) => {
                commit('SET_TOKEN', '')
                let token = Vue.ls.get(ACCESS_TOKEN)
                Vue.ls.remove(ACCESS_TOKEN)
                Vue.ls.remove(SEEKER_INFO)
                Vue.ls.remove(NAME)
                postAction('/logout', {'token': token}).then(response => {
                    resolve(response)
                }).catch(error => {
                    resolve(error)
                })
            })
        }
    }
}
export default seeker
